import { ENVIRONMENT } from '../config/config';

export const logger = {
  debug: (...args: any[]) => {
    if (ENVIRONMENT === 'development' || ENVIRONMENT === 'local') {
      console.log(...args);
    }
  },
  trace: (...args: any[]) => {
    if (ENVIRONMENT === 'development' || ENVIRONMENT === 'local') {
      console.trace(...args);
    }
  }
};
